import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@/components/ui/select'

export interface FilterOption<T extends string> {
    value: T
    label: string
}

interface FilterSelectProps<T extends string> {
    value: T
    onChange: (value: T) => void
    options: FilterOption<T>[]
    label: string
    className?: string
}

const FilterSelect = <T extends string>({ value, onChange, options, label, className }: FilterSelectProps<T>): ReactNode => {
    return (
        <Select
            items={options}
            value={value}
            onValueChange={next => {
                if (next) onChange(next as T)
            }}
        >
            <SelectTrigger aria-label={label} className={cn('bg-background data-[size=default]:h-10', className)}>
                <SelectValue />
            </SelectTrigger>

            <SelectContent alignItemWithTrigger={false} align='start'>
                {options.map(option => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}

export default FilterSelect
